import styled from 'styled-components';

export const CommissionTermItem = styled.div`
  display: flex;
  margin-bottom: 36px;
  padding-bottom: 36px;
  border-bottom: 1px solid #dfe3e7;
`;

export const TermSelectContainer = styled.div`
  flex-grow: 1;
`;

export const WarningContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  gap: 4px;
`;

export const WarningMessage = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: var(--color-tangerine);
`;
